import { Component, inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogTitle
} from '@angular/material/dialog';
import {TranslateModule} from "@ngx-translate/core";
import {MatButton} from "@angular/material/button";

@Component({
  selector: 'app-policy-modal',
  templateUrl: './app-policy-modal.component.html',
  imports: [
    MatDialogActions,
    TranslateModule,
    MatDialogContent,
    MatDialogTitle,
    MatDialogClose,
    MatButton
  ],
  standalone: true
})
export class AppPolicyModalComponent {
  data = inject<{
    title: string;
    content: string;
}>(MAT_DIALOG_DATA);

  constructor() {}
}
